var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.error)?_c('p',[_vm._v("Activating invitation...")]):_c('p',{staticClass:"error"},[_vm._v(_vm._s(_vm.error))])])
}
var staticRenderFns = []

export { render, staticRenderFns }